























































import AppVue from '../../AppVue.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WorkshopService, CompanyService } from '@/core/services';
import { ClientDetailHeaderCpt, WorkshopDetailHeaderCpt, WorkshopClientReplaceParticipantFormCpt } from './components';

import { WorkshopModel, CompanyModel, ParticipantModel, ReplaceParticipantModel } from '@/core/models';
@Component({
  components: {
    WorkshopDetailHeaderCpt,
    ClientDetailHeaderCpt,
    WorkshopClientReplaceParticipantFormCpt,
  },
})
export default class WorkshopClientReplaceParticipant extends AppVue {
  loading = false;
  model = {} as WorkshopModel;
  companyModel = new CompanyModel();
  participantModel = new ReplaceParticipantModel();

  currentParticipantModel = new ParticipantModel();

  get workshopId() {
    return Number(this.$route.params.workshopId);
  }
  get companyId() {
    return Number(this.$route.params.companyId);
  }
  get participantId() {
    return Number(this.$route.params.participantId);
  }

  async created() {
    this.initializeModel();
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.currentParticipantModel.userId = this.participantId;
      this.participantModel.previousUserId = this.participantId;
      this.participantModel.workshopId = this.workshopId;
      this.participantModel.companyId = this.companyId;

      this.model = await WorkshopService.getWorkshop(this.workshopId);

      const findCompany = this.model.companies.find((x: CompanyModel) => x.id === this.companyId);
      if (!findCompany) {
        this.notify('Error', 'The client cannot be retrieved.', 'error');
        return;
      }
      this.companyModel = findCompany;
      if (!this.participantId) {
        return;
      }
      if (this.participantId === this.companyModel.attendee1Id) {
        this.currentParticipantModel.fullName = this.companyModel.attendee1Name;
        this.currentParticipantModel.email = this.companyModel.attendee1Email;
      } else if (this.participantId === this.companyModel.attendee2Id) {
        this.currentParticipantModel.fullName = this.companyModel.attendee2Name;
        this.currentParticipantModel.email = this.companyModel.attendee2Email;
      } else {
        this.notify('Error', 'The participant cannot be retrieved.', 'error');
      }
    } finally {
      this.loading = false;
    }
  }
}
